import axios from 'axios'
// 创建axios实例
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// // 请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 如果配置中设置了 noAuth 为 true，则不添加 token
    if (config.noAuth) {
      return config;
    }
    // 添加认证token
    const token = localStorage.getItem('user_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
apiClient.interceptors.response.use(
  (response) => {
    // 处理成功响应

  
    switch(response.data.code){
       case 401:
          // 未授权，跳转到登录页
          window.location.href ="https://dev.henandingbu.top/#/wechat-auth/"
          return []
    }
    
    return response.data

  },
  (error) => {
    // 处理错误响应
    if (error.response) {
      // 根据状态码处理不同错误
      const status = error.response.status
      const message = error.response.data?.message || '请求失败'
      
      switch (status) {
        case 401:
          // 未授权，跳转到登录页
          console.error('未授权:', message)
          break
        case 403:
          // 禁止访问
          console.error('禁止访问:', message)
          break
        case 404:
          // 资源不存在
          console.error('资源不存在:', message)
          break
        case 500:
          // 服务器错误
          console.error('服务器错误:', message)
          break
        default:
          console.error('请求错误:', message)
      }
    } else if (error.request) {
      // 请求已发出但没有响应
      console.error('网络错误:', '请检查网络连接')
    } else {
      // 其他错误
      console.error('请求错误:', error.message)
    }
    
    return Promise.reject(error)
  }
)

/**
 * 微信授权相关API
 */

// 获取微信授权URL（后端生成）
export const getWechatAuthUrl = (redirectUri) => {
  return apiClient.get('/api/wechat/oauthUrl', {
    params: { redirect_uri: redirectUri }
  })
}

/**
 * 产品相关API
 */



// 获取产品列表
export const getProductsByCategory = (categoryId) => {
  return apiClient.get(`/api/product/getList?categroyId=${categoryId}`,)
}

// 获取产品详情
export const getProductDetail = (id) => {
  return apiClient.get(`/products/${id}`)
}


/**
 * 会员和会员卡信息API
 * 
 */
/**
 * 获取会员信息
 * @returns {Promise} 会员信息响应
 */
export const getMemberInfo = () => {
  return apiClient.get('/api/user/memberCard')
}

// 绑定手机号（直接使用token完成绑定）
export const bindPhoneWithToken = (bindData) => {
  return apiClient.post('/api/user/bindPhone', bindData)
}

// 绑定手机号（直接使用token完成绑定）
export const getUserInfoByCode = (code) => {
  return apiClient.post('/api/wechat/oauthCallback', {
    code
  })
}

/**
 * 生成核销二维码
 * @param {Object} data - 订单数据
 * @returns {Promise} 二维码响应
 */
export const generateQRCode = (data) => {
  return apiClient.post('/api/member/generateQr', data)
}

/**
 * 检查二维码状态
 * @param {String} qrCodeId - 二维码ID
 * @returns {Promise} 状态响应
 */
export const checkQRCodeStatus = (qrCodeId) => {
  return apiClient.get(`/api/member/qrStatus/${qrCodeId}`)
}

/**
 * 获取当天是否使用过
 */
export const isUse = () => {
  return apiClient.get('/api/user/isUse')
}

/**
 * 记录用户选择的要核销的产品
 */
export const confirmProductUse = (data) => {
  return apiClient.post('/api/user/useCard',data)
}

/**
 * 记录用户选择的要核销的产品
 */
export const getConfirmProduct = (data) => {
  return apiClient.post('/api/user/getConfirm',data, {
    noAuth: true // 添加自定义配置
  })
}

/**
 * 
 * 核销产品 writeOff
 */
export const writeOff = (data) => {
  return apiClient.post('/api/user/writeOff',data, {
    noAuth: true // 添加自定义配置
  })
}

/**
 * 轮询接口查询是否核销 checkVerificationStatus
 */
export const checkVerificationStatus = (data) => {
  return apiClient.post('/api/user/readOff',data)
}

/**
 * 获取使用记录
 * @returns {Promise} 使用记录响应
 */
export const getUsageHistory = () => {
    return apiClient.get('/api/user/writeOffRecord')
}
export default apiClient